"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRecipeLinkIngredientsToGroceryListMutationOptions = exports.addRecipeLinkIngredientsToGroceryListMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItem_1 = require("../fragments/groceryItem");
const groceryItems_1 = require("../queries/groceryItems");
exports.addRecipeLinkIngredientsToGroceryListMutation = client_1.gql `
  mutation AddRecipeLinkIngredientsToGroceryList(
    $groceryItemId: String!
    $recipeId: String!
    $amount: String
  ) {
    addRecipeLinkIngredientsToGroceryList(
      groceryItemId: $groceryItemId
      recipeId: $recipeId
      amount: $amount
    ) {
      groceryItems {
        ...GroceryListItem
      }
      recipes {
        ...GroceryRecipeInfo
      }
    }
  }
  ${groceryItem_1.groceryRecipeInfoFragment}
  ${groceryItem_1.groceryListItemFragment}
`;
exports.addRecipeLinkIngredientsToGroceryListMutationOptions = (variables) => ({
    variables,
    update: (store, { data: responseData }) => {
        if (responseData) {
            const { addRecipeLinkIngredientsToGroceryList: { groceryItems, recipes }, } = responseData;
            let data;
            try {
                data = store.readQuery({
                    query: groceryItems_1.groceryItemsQuery,
                });
            }
            catch (err) {
                return;
            }
            if (data && groceryItems) {
                store.writeQuery({
                    query: groceryItems_1.groceryItemsQuery,
                    data: {
                        __typename: "Query",
                        groceryItems: {
                            __typename: "GroceryItemsResponse",
                            recipes: [...recipes, ...data.groceryItems.recipes],
                            items: [
                                ...groceryItems,
                                ...data.groceryItems.items.filter(x => x.id !== variables.groceryItemId),
                            ],
                        },
                    },
                });
            }
        }
    },
});
//# sourceMappingURL=addRecipeLinkIngredientsToGroceryList.js.map